module.exports = __webpack_public_path__ + "static/media/product_2_BU1820.f12de9f4.jpg";